// action.ts – surface d’API du module prospect (public demos)

export {
  fetchPublicDemosMeta,
  fetchPublicDemosAvailability,
  fetchPublicDemoSessions,
  createPublicDemoSession,
  patchPublicDemoSession,
  deletePublicDemoSession,
} from './hooks/mutation';

